import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { io } from "socket.io-client";
import MILogo from "../../images/MI-Image.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { formatCurrency } from "../../utlis/utlis";

const socket = io(`${process.env.REACT_APP_API_WS_URL}`, {
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  transports: ["websocket"],  // ⭐ Force WebSocket only
  upgrade: false,              // ⭐ Disable polling upgrade
});

const MPUFailPage = () => {
  const location = useLocation();
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const data = params.get("data");
    if (data) {
      const parsedData = JSON.parse(decodeURIComponent(data));
      console.log("Parsed DATA:", parsedData);
      setPaymentDetails(parsedData);

      // setPaymentDetails(data);
    }
  }, [location]);

  const handleBackToMerchantClick = async () => {
    setLoading(true);

    try {
      // Make an API call to the backend to get the URL and JSON response
      const response = await axios.get(
        `${process.env.REACT_APP_API_BACKEND_URL}/v1/payments/backtomerchant`,
        {
          params: {
            invoiceNo: paymentDetails.invoiceNo, // Send invoiceNo as a query parameter
          },
          headers: {
            Authorization: `Bearer `,
          },
        }
      );

      // Extract data from the response
      const {
        backtoMerchantUrl,
        merchantCode,
        invoiceNo,
        currency,
        amount,
        paymentChannel,
        paymentStatus,
        responseCode,
      } = response.data;

      // Create a form and append hidden input fields for each parameter
      const form = document.createElement("form");
      form.method = "POST";
      form.action = backtoMerchantUrl;

      const data = {
        merchantCode,
        invoiceNo,
        currency,
        amount,
        paymentChannel,
        paymentStatus,
        responseCode,
      };

      // Create hidden input fields for each piece of data
      Object.keys(data).forEach((key) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = data[key];
        form.appendChild(input);
      });

      // Append the form to the body and submit it
      document.body.appendChild(form);
      form.submit();
    } catch (error) {
      console.error("Error redirecting to merchant:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {paymentDetails?.status === "FAILED" ? (
        <div className="container mt-5">
          {/* Header Section */}
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <img
                src={MILogo}
                alt="Logo"
                className="me-2" // Bootstrap class for margin-right
                style={{
                  objectFit: "cover",
                }}
              />
            </div>
          </div>

          {/* Amount Section */}
          <div className="mt-3">
            <h5 className="text-primary m-0">Pay for Myanma Insurance</h5>

            <div className="table-responsive">
              <table
                className="table"
                style={{ fontSize: "16px", width: "auto" }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        width: "55%",
                        fontWeight: "bold",
                      }}
                      className="text-start"
                    >
                      Total Amount :
                    </td>
                    <td className="text-end" style={{ fontWeight: "bold" }}>
                      {formatCurrency(
                        paymentDetails.amount,
                        paymentDetails.currencyCode
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "55%" }} className="text-start">
                      Transaction Amount :
                    </td>
                    <td className="text-end">
                      {formatCurrency(
                        paymentDetails.amount - paymentDetails.serviceCharges,
                        paymentDetails.currencyCode
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "55%" }} className="text-start">
                      Service Fee :
                    </td>
                    <td className="text-end">
                      {formatCurrency(
                        paymentDetails.serviceCharges,
                        paymentDetails.currencyCode
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }} className="text-start">
                      Invoice No. :
                    </td>
                    <td className="text-end">{paymentDetails.invoiceNo}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="container mt-4">
            <h5>MPU PAYMENT</h5>
          </div>

          {/* QR Payment Section */}
          <div className="mt-4">
            <div className="text-danger d-flex justify-content-center align-items-center mt-3">
              <h3>Transaction is Failed.</h3>
            </div>
          </div>

          {/* Instructions Section */}
          <div className="mt-4 text-center">
            <p>
              Save invoice number {paymentDetails.invoiceNo} for future
              reference.
            </p>
            <p>
              For any additional queries or help, please contact{" "}
              <u>it-support@thuriyaacetechnology.com</u>
            </p>
          </div>

          {/* Save QR Button */}
          <div className="text-center mt-5 mb-5">
            <button
              className="btn btn-primary"
              onClick={handleBackToMerchantClick}
              disabled={loading} // Disable the button while the API call is in progress
            >
              {loading ? "Redirecting..." : "BACK TO MERCHANT"}
            </button>
          </div>
        </div>
      ) : (
        "Loading..."
      )}
    </div>
  );
};

export default MPUFailPage;
